<template>
    <modal id="salary-sheet-view-modal"
           size="large"
           v-model="showModal"
           :title="$fieldTitle('view', 'salary', true)"
           :cancel-btn-label="$t('close')"
           :hide-submit-button="true"
           :preloader="preloader">

        <div class="d-flex justify-content-center mb-primary">
            <div class="text-center">
                <img :src="logo" alt="logo" class="radius-5" style="max-height: 100px; max-width: 150px;"/>
            </div>
        </div>

        <div class="d-flex justify-content-between mb-primary py-primary">
            <div class="">
                <app-user-media
                    :row-data="rowData.employee"
                    :value="rowData.employee.profile_picture"
                    :prefix="rowData.employee.profile.employee_id + ' '"
                />
            </div>
            <div>
                <p class="m-0">{{ $t('month') }} : <span class="text-info">{{ formData.month }}</span></p>
                <p class="m-0">{{ $t('created_at') }} : {{ formatDateToLocal(formData.created_at) }}</p>
            </div>
            <div>
                <p class="m-0">{{ $t('designation') }} :
                    {{ rowData.employee.designation ? rowData.employee.designation.name : 'None' }}</p>
                <p class="m-0">{{ $t('department') }} :
                    {{ rowData.employee.department ? rowData.employee.department.name : 'None' }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mt-primary">
                <div class="d-flex justify-content-between border-bottom">
                    <h6>{{ $t('basic_salary') }}</h6>
                    <h6>{{ formatCurrency(numberFormatter(Number(formData.base_salary))) }}</h6>
                </div>
            </div>
            <div class="col-md-12">
                <div class="mb-primary mt-primary">
                    <div class="d-flex justify-content-between border-bottom mb-2">
                        <h6>{{ $t('beneficiary') }}</h6>
                    </div>

                    <div class="mb-3">
                        <div class="row">
                            <div class="col-4">
                                <div class="d-flex justify-content-between border-bottom mb-2">
                                    <h6>{{ this.$t('information') }}</h6>
                                </div>
                                <template v-for="information in selectedInformation">
                                    <div class="mb-2 d-flex justify-content-between">
                                        <p class="m-0 text-size-12">
                                            {{ information.name }}
                                        </p>
                                        <p class="m-0 text-size-12">
                                            {{ numberFormatter(Number(formData.informationValues[information.id])) }}
                                        </p>
                                    </div>
                                </template>
                            </div>
                            <div class="col-4">
                                <div class="d-flex justify-content-between border-bottom mb-2">
                                    <h6>{{ this.$t('allowances') }}</h6>
                                </div>
                                <template v-for="allowance in selectedAllowances">
                                    <div class="mb-2 d-flex justify-content-between">
                                        <p class="m-0 text-size-12">
                                            {{ allowance.name }}
                                        </p>
                                        <p class="m-0 text-size-12">
                                            {{ formatCurrency(numberFormatter(Number(formData.allowanceValues[allowance.id]))) }}
                                        </p>
                                    </div>
                                </template>
                            </div>
                            <div class="col-4">
                                <div class="d-flex justify-content-between border-bottom mb-2">
                                    <h6>{{ this.$t('deductions') }}</h6>
                                </div>
                                <template v-for="deduction in selectedDeductions">
                                    <div class="mb-2 d-flex justify-content-between">
                                        <p class="m-0 text-size-12">
                                            {{ deduction.name }}
                                        </p>
                                        <p class="m-0 text-size-12">
                                            {{ formatCurrency(numberFormatter(Number(formData.deductionValues[deduction.id]))) }}
                                        </p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-4">
                                <div class="d-flex justify-content-between">
                                    <p class="m-0">{{ this.$t('total_information') }}</p>
                                    <p class="m-0">{{ numberFormatter(totalInformation) }}</p>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="d-flex justify-content-between">
                                    <p class="m-0">{{ this.$t('total_allowance') }}</p>
                                    <p class="m-0">{{ formatCurrency(numberFormatter(totalAllowances)) }}</p>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="d-flex justify-content-between">
                                    <p class="m-0">{{ this.$t('total_deduction') }}</p>
                                    <p class="m-0">{{ formatCurrency(numberFormatter(totalDeductions)) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between border-bottom mb-primary mt-3">
                        <h6>{{ $t('beneficiary_amount') }}</h6>
                        <h6>{{ formatCurrency(numberFormatter(totalBeneficiary)) }}</h6>
                    </div>

                    <div class="d-flex justify-content-between border-bottom mb-primary">
                        <h6>{{ $t('net_payable_salary') }}</h6>
                        <h6>{{ formatCurrency(numberFormatter(formData.net_salary)) }}</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mt-primary">
                <div class="d-flex justify-content-between border-bottom mb-3">
                    <h6>{{ $t('note') }}</h6>
                </div>
                <p>{{ formData.note }}</p>
            </div>
        </div>
        <template slot="footer">
            <div class="d-flex justify-content-end align-items-center w-100">
                <template v-if="$can('view_payslip_pdf')">
                    <button type="button"
                            class="btn btn-primary mr-2"
                            @click.prevent="openPdf()">
                        {{ $t('view_pdf') }}
                    </button>
                    <button type="button"
                            class="btn btn-primary mr-2"
                            @click.prevent="openPdf(true)">
                        {{ $t('download_pdf') }}
                    </button>
                </template>
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                    {{ $t('close') }}
                </button>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {formatDateToLocal} from "../../../../common/Helper/Support/DateTimeHelper";
import {formatCurrency, numberFormatter} from "../../../../common/Helper/Support/SettingsHelper";

export default {
    name  : "SalarySheetViewModal",
    mixins: [ModalMixin],
    props : {
        rowData: {},
    },
    data() {
        return {
            TENANT_BASE_URL,
            beneficiaries      : [],
            selectedInformation: [],
            selectedAllowances : [],
            selectedDeductions : [],
            formData           : {
                information      : [],
                informationValues: {},
                allowances       : [],
                allowanceValues  : {},
                deductions       : [],
                deductionValues  : {},
                net_salary       : 0,
            },
        }
    },
    created() {
        this.getBeneficiaries();
        this.fromGetEditData(this.rowData);
    },
    computed: {
        logo() {
            return this.$store.state.settings.tenant_logo
                   ? urlGenerator(this.$store.state.settings.tenant_logo)
                   : urlGenerator('/images/logo/default-logo.png')
        },
        information() {
            return this.beneficiaries.filter(benefit => benefit.type === 'information');
        },
        allowances() {
            return this.beneficiaries.filter(benefit => benefit.type === 'allowance');
        },
        deductions() {
            return this.beneficiaries.filter(benefit => benefit.type === 'deduction');
        },
        totalBeneficiary() {
            return Number(this.totalAllowances - this.totalDeductions);
        },
        totalInformation() {
            let total = 0;
            this.formData.information.forEach(id => {
                const informationValue = this.formData.informationValues[id] ? Number(this.formData.informationValues[id]) : 0;
                total += informationValue;
            })
            return total;
        },
        totalAllowances() {
            let total = 0;
            this.formData.allowances.forEach(id => {
                const allowanceValue = this.formData.allowanceValues[id] ? Number(this.formData.allowanceValues[id]) : 0;
                total += allowanceValue;
            })
            return total;
        },
        totalDeductions() {
            let total = 0;
            this.formData.deductions.forEach(id => {
                const deductionValue = this.formData.deductionValues[id] ? Number(this.formData.deductionValues[id]) : 0;
                total += deductionValue;
            })
            return total;
        },
    },
    methods : {
        numberFormatter,
        formatCurrency,
        formatDateToLocal,
        getBeneficiaries() {
            this.preloader = true;
            axiosGet(this.apiUrl.SELECTABLE_BENEFICIARY_BADGE).then(({data}) => {
                this.beneficiaries = data
            }).finally(() => {
                this.preloader = false;
            })
        },
        fromGetEditData(data) {
            this.formData            = {
                ...{
                    information      : [],
                    informationValues: {},
                    allowances       : [],
                    allowanceValues  : {},
                    deductions       : [],
                    deductionValues  : {},
                    net_salary       : 0,
                },
                ...data
            };
            this.preloader           = false;
            this.formData.net_salary = Number(this.formData.base_salary)
            this.selectedInformation = []
            this.selectedAllowances  = []
            this.selectedDeductions  = []

            if (this.formData.items.length > 0) {
                const informationData = this.formData.items.filter(benefit => benefit.type === 'information');
                const allowancesData  = this.formData.items.filter(benefit => benefit.type === 'allowance');
                const deductionsData  = this.formData.items.filter(benefit => benefit.type === 'deduction');

                informationData.forEach(item => {
                    this.$set(this.formData.informationValues, item.salary_item_id, item.value);
                    this.formData.information.push(item.salary_item_id)
                    this.selectedInformation.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                })
                allowancesData.forEach(item => {
                    this.$set(this.formData.allowanceValues, item.salary_item_id, item.value);
                    this.formData.allowances.push(item.salary_item_id)
                    this.selectedAllowances.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                    this.formData.net_salary += Number(item.value)
                })
                deductionsData.forEach(item => {
                    this.$set(this.formData.deductionValues, item.salary_item_id, item.value);
                    this.formData.deductions.push(item.salary_item_id)
                    this.formData.net_salary -= Number(item.value)
                    this.selectedDeductions.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                })
            }
        },
        openPdf(download = false) {
            const pdfLink = `${TENANT_BASE_URL}app/salary-sheet/${this.rowData.id}/pdf`;
            const link = download ? `${pdfLink}?download=true` : pdfLink;
            window.open(urlGenerator(link), "_blank") || window.location.replace(urlGenerator(link));
        },
    }
}
</script>
